
@switch (!!item) {
  @case (false) {
    <action class="button-2 p-r-0 p-l-0 icon-button"
      [ngClass]="{'icon-button--small' : small}"
      [icon]="inWishlist ? 'wishlist-fill' : 'wishlist'"
      [status]="status"
      notification="Wishlist error"
      (click)="toggle()"
      cy-wishlistAddBtn>
    </action>
  }
  @case (true) {
    <action class="button-2 p-r-0 p-l-0 icon-button"
      [ngClass]="{'icon-button--small' : small}"
      [icon]="'close'"
      [status]="status"
      notification="Wishlist error"
      (click)="removeItem()"
      cy-wishlistAddBtn>
    </action>
  }
}
